module.exports = function setUpScroller() {

  var scroller = document.querySelector('.js-projects-list');
  
  function setUpArrows() {
    var up = document.querySelector('.js-projects-up');
    var down = document.querySelector('.js-projects-down');

    if (up) {
      up.addEventListener('click', function () {
        scroller.scrollTop = scroller.scrollTop - 43 * 5;
      });
    }

    if (down) {
      down.addEventListener('click', function() {
        scroller.scrollTop = scroller.scrollTop + 43 * 5;
      });
    }
  }

  function updateScrollerPosition() {
    if (scroller) {
      if (scroller.scrollTop > 0) {
        scroller.classList.add('is-scrolling-top');
      } else {
        scroller.classList.remove('is-scrolling-top');
      }

      if (scroller.clientHeight + scroller.scrollTop !== scroller.scrollHeight) {
        scroller.classList.add('is-scrolling-bottom');
      } else {
        scroller.classList.remove('is-scrolling-bottom');
      }
    }
  }

  setUpArrows();
  scroller.addEventListener('scroll', updateScrollerPosition);
  window.addEventListener('resize', updateScrollerPosition);
  return updateScrollerPosition;

}
